import {ButtonHTMLAttributes, ReactElement} from "react";
import {Button} from "@/components/buttons/Button";

function MagicLoginSuccess(): ReactElement {
    return (
        <div>
            <p>
                Please check your email.
            </p>
            <p>
                Your login link has been sent to your email and you can click it to login.
                If it doesn't show up, check your email's spam box.
            </p>
            <p>
                Please refresh this page after you have logged in.
            </p>
            <Button variant="primary"
                onClick={() => window.location.reload()}
            >
                Refresh
            </Button>
        </div>
    );
}

export default MagicLoginSuccess;